<template>
    <main-content-marketing>
        <subsets></subsets>
    </main-content-marketing>
</template>

<script>
    import Subsets from "@/pages/marketing/subsets";
    import MainContentMarketing from "@/components/main-content-marketing";

    export default {
        name: "Get",
        components: {MainContentMarketing, Subsets},
        mounted(){

        setTimeout(() => {
            if(this.pos_visitor){
                return
            }else{
                document.getElementById('read_access').style.display = 'none'
            }
        }, 3000);
        }
    }
</script>

<style scoped>

</style>